export default __webpack_public_path__ + "static/media/OSM-slider5.28a8b3bf.jpg";